export default __webpack_public_path__ + "static/media/dps-logo-black.e7e4d920.svg";